module.exports = __webpack_public_path__ + "img/category-brand.2e745544.png";